import React, { useEffect, useState } from 'react';
import { getwayApi } from '../../../config/Constants';
import { ConfirmationPage } from './ConfirmationPage'
import axios from "axios";

export const ConfirmationPageContainer = ({ session }) => {
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(true);
    const [sessionID, setSessionID] = useState(session.id);



    useEffect(() => {
        const logData = window.location.origin.includes('app-vra.azurewebsites.net') || window.location.origin.includes('app-vra-test') || window.location.origin.includes('localhost');

        // only log if in dev
        function log(str) {
            if (logData) {
                console.log(str);
            }
        }

        const delay = millis => new Promise((resolve, reject) => {
            setTimeout(_ => resolve(), millis)
        });


        const doFetch = async () => {
            let tryCount = 20;
            for (var iTry = 0; iTry < tryCount; iTry++) {
                log("Access code fetch: " + iTry.toString());
                try {
                    let response = await axios.get(`${getwayApi}/api/session/conformation/${sessionID}`).catch(err => {
                        log("Error caught in fetch");
                        console.log(err);
                    });

                    if (response && response.status === 200) {
                        log("Response came back.");
                        log(response);

                        setConfig(response.data);
                        setLoading(false);
                        break;

                    } else {
                        log("Invalid response");
                        log(response);
                        await delay(2000); // sleep for 2 seconds before retrying.
                    }
                } catch (error) {
                    log("Error caught in fetch");
                    console.log(error);
                }
            }
        };

        log("Running fetch on session:" + sessionID);
        doFetch();
    }, [sessionID]);




    return (
        <>
            {loading && <div>loading</div>}
            {/* {!loading && <ConfirmationPage session={session.id} config={JSON.parse(config.confirmSpecs)} textImage = {config.textImage} trackingLink={config.trackingLink} surveryLink={config.surveryLink} formId={config.formId}/>} */}
            {!loading && <ConfirmationPage session={session.id} config={JSON.parse(config.confirmSpecs)} textImage={config.textImage} trackingLink={config.trackingLink} surveryLink={config.surveryLink} formId={config.formId} />}
        </>
    )


}